import React from "react";
import styled from "styled-components";
import { typography } from "../../styles/designSystem";

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 100px;
`;

const Icon = styled.img`
    height: 60px;
    object-fit: contain;
    margin-bottom: 0.5rem;
    filter: ${({ theme }) => theme.logoFilter || 'none'};
`;

const Label = styled.span`
    font-family: ${typography.fontFamily.display};
    font-size: 0.72rem;
    text-transform: uppercase;
    letter-spacing: ${typography.letterSpacing.wide};
    text-align: center;
    color: ${({ theme }) => theme.subtleText};
`;

const ToolIconCard = ({ src, alt, label }) => (
    <Wrapper>
        <Icon src={src} alt={alt} />
        <Label>{label}</Label>
    </Wrapper>
);

export default ToolIconCard;
